(function () {
  /*
   * Modulo do componenet agenda-list (avisosList)
   */
  angular
    .module('minhaTurmaListModule', []);
})();
